__turbopack_context__.v({
  "heading2": "RichText-module-scss-module__7RYDhG__heading2",
  "heading3": "RichText-module-scss-module__7RYDhG__heading3",
  "heading4": "RichText-module-scss-module__7RYDhG__heading4",
  "heading5": "RichText-module-scss-module__7RYDhG__heading5",
  "heading6": "RichText-module-scss-module__7RYDhG__heading6",
  "image": "RichText-module-scss-module__7RYDhG__image",
  "imageLink": "RichText-module-scss-module__7RYDhG__imageLink",
  "link": "RichText-module-scss-module__7RYDhG__link",
  "list": "RichText-module-scss-module__7RYDhG__list",
  "listItem": "RichText-module-scss-module__7RYDhG__listItem",
  "paragraph": "RichText-module-scss-module__7RYDhG__paragraph",
  "root": "RichText-module-scss-module__7RYDhG__root",
});
